<template>
    <div>
        <MainLayout>
            <div class="home-content">
                <div class="home">
                    <h1>404 {{ $t('general_page_not_found') }}</h1>
                </div>
            </div>
        </MainLayout>
    </div>
</template>

<script>
    import MainLayout from '../components/MainLayout.vue';

    export default {
        name: 'PageNotFound',
        components: {
            MainLayout,
        }
    }
</script>

<style scoped>
</style>
